import { useState } from "react";
import "./ContactPage.css";

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
    </svg>
  );
}

function PinterestIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" width="24" height="24">
      <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
    </svg>
  );
}

export default function ContactPage() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSending(true);
    try {
      await fetch("/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      setSent(true);
    } catch {
      setSent(true);
    }
    setSending(false);
  }

  const contactCards = [
    {
      id: "address",
      icon: "📍",
      label: "OUR OFFICE",
      title: "Pallatet Agimi",
      sub: "Tirana, Albania",
      href: "https://maps.google.com/?q=Pallatet+Agimi+Tirane+Albania",
      color: "#c8956c",
      bg: "rgba(200,149,108,0.12)",
    },
    {
      id: "phone",
      icon: "📞",
      label: "PHONE",
      title: "+355 69 434 3590",
      sub: "Mon–Sun, 8:00 – 22:00",
      href: "tel:+355694343590",
      color: "#4a9e6b",
      bg: "rgba(74,158,107,0.12)",
    },
    {
      id: "whatsapp",
      svgIcon: <WhatsAppIcon />,
      label: "WHATSAPP",
      title: "+355 69 434 3590",
      sub: "Quick replies via WhatsApp",
      href: "https://wa.me/355694343590",
      color: "#25d366",
      bg: "rgba(37,211,102,0.12)",
    },
    {
      id: "email",
      icon: "✉️",
      label: "EMAIL",
      title: "info@bookingalb.com",
      sub: "We reply within a few hours",
      href: "mailto:info@bookingalb.com",
      color: "#7c6af7",
      bg: "rgba(124,106,247,0.12)",
    },
    {
      id: "instagram",
      svgIcon: <InstagramIcon />,
      label: "INSTAGRAM",
      title: "@bookingalb",
      sub: "Follow us for inspiration",
      href: "https://www.instagram.com/bookingalb?igsh=MTByMnU1aHEyNTAzMA%3D%3D",
      color: "#e1306c",
      bg: "rgba(225,48,108,0.12)",
    },
    {
      id: "pinterest",
      svgIcon: <PinterestIcon />,
      label: "PINTEREST",
      title: "BookingAlb",
      sub: "Discover Albanian travel ideas",
      href: "https://pin.it/6wIjol2Fn",
      color: "#e60023",
      bg: "rgba(230,0,35,0.12)",
    },
  ];

  return (
    <div className="cp-page">

      {/* HERO */}
      <div className="cp-hero">
        <div className="cp-hero-inner">
          <div className="eyebrow" style={{ justifyContent: "center" }}>
            <div className="eline"></div>
            <span className="etxt">Get In Touch</span>
            <div className="eline"></div>
          </div>
          <h1 className="cp-hero-title">We are here <em>to help</em></h1>
          <p className="cp-hero-sub">Have a question about a property? Need help planning your Albanian adventure? Our local team is ready to assist you.</p>
        </div>
      </div>

      <div className="cp-body">
        <div className="container">
          <div className="cp-layout">

            {/* LEFT — Contact Cards */}
            <div className="cp-cards">
              {contactCards.map(function(card) {
                return (
                  <a
                    key={card.id}
                    href={card.href}
                    target={card.id !== "phone" && card.id !== "email" ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    className="cp-card"
                  >
                    <div className="cp-card-icon" style={{ background: card.bg, color: card.color }}>
                      {card.svgIcon || card.icon}
                    </div>
                    <div className="cp-card-info">
                      <span className="cp-card-label">{card.label}</span>
                      <span className="cp-card-title">{card.title}</span>
                      <span className="cp-card-sub">{card.sub}</span>
                    </div>
                    <div className="cp-card-arrow">›</div>
                  </a>
                );
              })}
            </div>

            {/* RIGHT — Form */}
            <div className="cp-form-wrap">
              {sent ? (
                <div className="cp-success">
                  <div className="cp-success-icon">✓</div>
                  <h3>Message Sent!</h3>
                  <p>Thank you for reaching out. We'll get back to you within a few hours.</p>
                </div>
              ) : (
                <>
                  <h2 className="cp-form-title">Send a Message</h2>
                  <p className="cp-form-sub">Fill in the form and we'll reply as soon as possible.</p>
                  <form className="cp-form" onSubmit={handleSubmit}>
                    <div className="cp-field">
                      <label>FULL NAME *</label>
                      <input type="text" name="name" placeholder="John Smith" value={form.name} onChange={handleChange} required />
                    </div>
                    <div className="cp-field">
                      <label>PHONE</label>
                      <input type="tel" name="phone" placeholder="+355 69 123 4567" value={form.phone} onChange={handleChange} />
                    </div>
                    <div className="cp-field">
                      <label>EMAIL *</label>
                      <input type="email" name="email" placeholder="john@example.com" value={form.email} onChange={handleChange} required />
                    </div>
                    <div className="cp-field">
                      <label>MESSAGE *</label>
                      <textarea name="message" placeholder="Tell us how we can help you..." value={form.message} onChange={handleChange} required rows={5} />
                    </div>
                    <button type="submit" className="cp-submit" disabled={sending}>
                      {sending ? "Sending..." : "✉ Send Message"}
                    </button>
                    <div className="cp-quick-btns">
                      <a href="https://wa.me/355694343590" target="_blank" rel="noopener noreferrer" className="cp-quick-btn cp-wa">
                        <WhatsAppIcon /> WhatsApp
                      </a>
                      <a href="tel:+355694343590" className="cp-quick-btn cp-call">
                        📞 Call Us
                      </a>
                    </div>
                  </form>
                </>
              )}
            </div>

          </div>

          {/* MAP */}
          <div className="cp-map-wrap">
            <iframe
              title="BookingAlb Location"
              className="cp-map"
              src="https://maps.google.com/maps?q=Pallatet+Agimi+Tirane+Albania&output=embed"
              allowFullScreen
              loading="lazy"
            />
          </div>

        </div>
      </div>
    </div>
  );
}